module.exports = ".search{padding:10px 9px}.search input{width:100%;border:none;outline:none}\n"